import { Component } from '@angular/core';
import { UilabAppBarModule } from '@uilab/core-angular';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface AppBarExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-app-bar-examples',
    templateUrl: './app-bar-examples.component.html',
    styleUrls: ['./app-bar-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabAppBarModule,
    ],
})
export class AppBarExamplesComponent {
    readonly packageName = '@uilab/core-angular';
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://jolly-wave-023d3c403.6.azurestaticapps.net/?path=/docs/components-organisms-top-app-bar--docs';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?path=%2Fpackages%2Fuilab-core%2Fsrc%2Fapp%2Forganisms%2Fapp-bar&version=GBmain&_a=contents';

    readonly examples: readonly AppBarExample[] = [
        {
            variant: 'basic',
            label: 'Basic App Bar',
            description:
                'Use an app bar to show branding and global actions at the top of the page.',
            htmlSnippet: `<uilab-app-bar
    appName="Design System"
    companyName="AVEVA"
></uilab-app-bar>`,
        },
    ];
}
